@if (!objectUsageCount) {
  <div class="object-usage-field__object-unused">
    <mat-icon>
      check_circle
    </mat-icon>

    <span>
      {{ 'TRANS__OBJECT_USAGE__NONE_ARE_USED' | translate }}
    </span>
  </div>
} @else {
  <div>
    @if (objectUsage.objectsUsing.length) {
      <button
        mat-stroked-button
        color="primary"
        type="button"
        class="object-usage-field__button"
        (click)="toggleShowUsage(objectUsage)"
        [ngClass]="{'active': objectUsage.showItems}"
      >
              <span class="object-usage-field__button-text bold">
                <span>
                  {{ objectUsage.objectName }}
                </span>

                <span>
                  ({{ objectUsageCount }})
                </span>
              </span>

        <mat-icon>
          {{ objectUsage.showItems ? 'expand_less' : 'expand_more' }}
        </mat-icon>
      </button>
    }

    @if (lastShowUsage?.showItems) {
      <mat-chip-listbox class="object-usage-field__objects">
        @for (objectUsing of lastShowUsage.objectsUsing; track $index) {
          <mat-chip-option class="object-usage-field__object">
            {{ objectUsing.artifact_name }}
          </mat-chip-option>
        }
      </mat-chip-listbox>

      @if (objectUsageStart >= objectUsageRows || objectUsageCount > objectUsageStart + objectUsageRows) {
        <div class="object-usage-field__more">
          @if (objectUsageStart >= objectUsageRows) {
            <button mat-stroked-button color="primary" type="button" (click)="previousItems()">
              {{ 'TRANS__OBJECT_USAGE__PREVIOUS_OBJECTS' | translate }}
            </button>
          }

          @if (objectUsageCount > objectUsageStart + objectUsageRows) {
            <button mat-stroked-button color="primary" type="button" (click)="nextItems()">
              {{ 'TRANS__OBJECT_USAGE__MORE_OBJECTS' | translate:{count: objectUsageCount - lastShowUsage.objectsUsing.length} }}
            </button>
          }
        </div>
      }
    }
  </div>
}
